export function initCampaignScript() {
  const campaignContainer = document.querySelector(".campaign-container");

  if (campaignContainer) {
    new Swiper(campaignContainer, {
      loop: false,
      spaceBetween: 16,
      grabCursor: true,
      autoHeight: true,

      autoplay: {
        delay: 3000,
      },
      navigation: {
        nextEl: ".go-next-campaign",
        prevEl: ".go-prev-campaign",
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },
    });
  }
}

// Check if we are in an ACF block preview environment and hook into its render action.
if (window.acf) {
  window.acf.addAction(
    "render_block_preview/type=campaign",
    initCampaignScript
  );
} else {
  document.addEventListener("DOMContentLoaded", function () {
    initCampaignScript();
  });
}
